import { render, staticRenderFns } from "./createminappconfig.vue?vue&type=template&id=7c658376&"
import script from "./createminappconfig.vue?vue&type=script&lang=ts&"
export * from "./createminappconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createminappconfig.vue"
export default component.exports